import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: 'https://key.brihha.com',
    realm: 'uksc-realm',
    clientId: 'uksc-lms-client',
});

export default keycloak;

